import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from './connect';
import { copy } from 'utils';
import { Col, Panel, Alert, Row, Button, FormGroup, ControlLabel, FormControl, InputGroup, Well } from 'react-bootstrap';
import * as PageTemplates from './templates/pages';
import Select, { Creatable } from 'react-select';
import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import moment from 'moment';
import SectionOrderer from './section-orderer';
import SectionProducer from './section-producer';
import * as Api from 'api';
import RichTextEditor from './rich-text-editor';
import SectionSelector from './section-selector';
import PageTemplateSelector from './page-template-selector';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const transformPageForSave = page => ({
  ...page,
  template: page.template && page.template._id || page.template,
  sections: (page.sections || []).map(section => section && section._id || section)
});

class PageProducer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      last_autosave: null,
      creating_section: false,
      validation_errors: [],
      page: {
        path: '',
        tags: [],
        title: '',
        author: '',
        sections: [],
        permissions: [],
        description: '',
        published: false,
        published_timestamp: new Date(),
        details: {
          body_content_type: 'html',
          body: ''
        }
      }
    }

    this.save = this.save.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.setStateWithPage = this.setStateWithPage.bind(this);
    this.handleSelectSections = this.handleSelectSections.bind(this);
    this.handlePageBodyChange = this.handlePageBodyChange.bind(this);
    this.handlePublishTimestamp = this.handlePublishTimestamp.bind(this);
    this.handleSelectPageTemplate = this.handleSelectPageTemplate.bind(this);
    this.handlePageDescriptionChange = this.handlePageDescriptionChange.bind(this);
  }
  save() {
    if(!this.state.page._id) {
      this.props.createPage(transformPageForSave(this.state.page));
      this.setState({
        last_autosave: new Date()
      });
    } else {
      this.props.updatePage(transformPageForSave(this.state.page));
      this.setState({
        last_autosave: new Date()
      });
    }
  }
  validateValue(name, value) {
    switch(name) {
      case 'path': {
        const test = (value || '').toLowerCase().match(/^((-|_|[a-z]|[0-9])*\/?)*$/gi);
        if(test) {
          return true;
        }
        else {
          return false
        }
        return
      }
      default: {
        return true;
      }
    }
  }
  handlePageChange(name, value) {
    const isValid = this.validateValue(name, value);
    if(!isValid) {
      return;
    }
    if(this.autoSave) {
      clearTimeout(this.autoSave);
    }

    this.autoSave = setTimeout(this.save, 3000);

    this.setState({
      dirty: true,
      page: {
        ...this.state.page,
        [name]: value
      }
    });
  }
  handlePathChange(value) {
    this.handlePageChange('path', value)
  }
  handleSelectSections(sections) {
    const newSections = sections.map(id => {
      return this.state.page.sections.find(({_id}) => _id == id) || this.props.section_manager.results.find(({_id}) => _id == id);
    }).filter(item => item);
    this.handlePageChange('sections', [...newSections]);
  }
  handlePageDescriptionChange(description) {
    this.setState({
      page: {
        ...this.state.page,
        description
      }
    });
  }
  handlePageBodyChange(body) {
    this.setState({
      page: {
        ...this.state.page,
        details: {
          ...this.state.page.details,
          body
        }
      }
    });
  }
  handlePublishTimestamp(event, picker) {
    this.handlePageChange('published_timestamp', picker.startDate.toDate());
  }
  handleSelectPageTemplate(value) {
    const template = this.props.page_template_manager.results.find( ({_id}) => _id == value );
    this.handlePageChange('template', { ...template });
  }
  componentDidMount() {

    this.unlisten = this.props.router.listenBefore(f => {
      if(this.state.dirty) {
        return 'You have unsaved changes, are you sure you want to leave?';
      }
    });

    /** Fetch Page if it isn't in the state. **/
    const page = this.props.page_manager.results.find(({ _id }) => _id == this.props.pageId);
    if(!page) {
      this.props.fetchPages({ _id: this.props.pageId, populate: 'sections template' });
    }
    else {
      this.setState({
        ...this.state,
        page: {
          ...page,
          details: page.details ? {
            body_content_type: page.details.body_content_type || 'html',
            body: page.details.body || '',
          } : {
            body_content_type: 'html',
            body: ''
          }
        }
      });
    }
  }
  setStateWithPage(page, ...args) {
    this.setState({
      ...this.state,
      dirty: false,
      page: {
        ...page,
        details: page.details ? {
          body_content_type: page.details.body_content_type || 'html',
          body: page.details.body || ''
        } : {
          body_content_type: 'html',
          body: ''
        },
        published_timestamp: page.published_timestamp || new Date()
      }
    }, ...args)
  }
  componentWillReceiveProps(nextProps) {
    const page = nextProps.page_manager.results.find( ({ _id }) => _id == (this.props.pageId || this.state.page._id));
    if(page && this.state.page._id != page._id) {
      this.setStateWithPage(page);
    }
    const { page_manager: next_pm } = nextProps;
    const { page_manager: this_pm } = this.props;

    if(this_pm.creating && !next_pm.creating && !next_pm.error) {
      const createdPage = nextProps.page_manager.results.find(({ _id }) => _id == next_pm.last_created_id);
      this.setStateWithPage(createdPage, () => {
        if(this.props.onCreate) {
          this.props.onCreate(createdPage);
        }
      });
    }

    if(this_pm.updating && !next_pm.updating && !next_pm.error) {
      const updatedPage = nextProps.page_manager.results.find(({ _id }) => _id == next_pm.last_updated_id);
      this.setStateWithPage(updatedPage, () => {
        if(this.props.onUpdate) {
          this.props.onUpdate(updatedPage);
        }
      });
    }

    if(page && !this.state.published && page.published) {
      if(this.props.onPublish) this.props.onPublish(page);
    }
  }
  componentWillUnmount() {
    this.unlisten();
  }
  render() {
    const { page_template, page, dirty, last_autosave, creating_section } = this.state;
    const { section_manager, page_manager } = this.props;
    const TemplateComponent = PageTemplates[page_template? page_template.reactComponentName || 'Default' : 'Default'];
    const label = moment(page.published_timestamp).format('MMM DD, YYYY hh:mm a');
    return (
      <Row className='animated fadeIn'>
        <Col xs={12}>
          <div style={{ textAlign: 'bottom'}}>
            <h1 style={{ display: 'inline' }}>{page.title || 'Page'}</h1><h3 style={{ display: 'inline' }}> /{page.path}</h3>
          </div>
        </Col>
        <Col xs={12} md={8}>
          <Row>
            <Col xs={12} md={6}>
              <FormGroup>
                <ControlLabel>Title</ControlLabel>
                <FormControl onChange={e => this.handlePageChange('title', e.target.value)} placeholder='Enter Page Title' value={page.title} />
              </FormGroup>
            </Col>
            <Col xs={12} md={6}>
              <FormGroup>
                <ControlLabel>Page Template</ControlLabel>
                <PageTemplateSelector
                  onSelect={this.handleSelectPageTemplate}
                  page_templates={page.template ? [ page.template ] : []}
                />
              </FormGroup>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <ControlLabel>Tags (SEO)</ControlLabel>
                <Creatable
                  multi
                  options={page.tags.map(tag => ({ label: tag, value: tag }))}
                  value={page.tags}
                  onChange={(values) => this.handlePageChange('tags', values.map(({ value }) => value))}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel>Path</ControlLabel>
                <FormControl onChange={e => this.handlePageChange('path', e.target.value.toLowerCase())} placeholder='Enter Page Path' value={page.path} />
              </FormGroup>
              <FormGroup>
                <ControlLabel>Description (SEO)</ControlLabel>
                <Panel>
                  <RichTextEditor
                    type='html'
                    text={page.description}
                    onChange={value => this.handlePageChange('description', value)}
                  />
                </Panel>
              </FormGroup>
              <FormGroup>
                <ControlLabel>Sections</ControlLabel>
                <Row>
                  {!creating_section ? <Col xs={10}>
                    <SectionSelector
                      multi
                      onSelect={this.handleSelectSections}
                      sections={page.sections}
                    />
                    {/* <Select
                      multi
                      onChange={this.handleSelectSections}
                      onInputChange={this.getSectionOptions}
                      isLoading={section_manager.loading}
                      options={[
                        ...page.sections,
                        ...section_manager.results
                          .filter(sectionTemplate => !page.sections.find(i => i._id == sectionTemplate._id))
                      ].map(section => ({ label: section.title, value: section._id }))}
                      placeholder='Find Sections'
                      value={page.sections.map(section => section._id)}
                    /> */}
                  </Col> : null}
                  {!creating_section ? <Col xs={2}>
                    <Button onClick={e => this.setState({ creating_section: true })} block bsStyle='success'><i className="fa fa-plus"></i> Section</Button>
                  </Col> : null}
                  <Col xs={12}>
                    {creating_section ? (
                      <Well className='bg-quaternary'>
                        <SectionProducer
                          onPublish={section => {
                            this.setState({
                              creating_section: false
                            })
                            this.handleSelectSections([ section ])
                          }}
                        />
                      </Well>
                    ) : (
                      null
                    )}
                  </Col>
                  <Col xs={12}>
                    <SectionOrderer order={[]} sections={page.sections} onChange={sections => this.handlePageChange('sections', sections)} />
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <ControlLabel>Body Content</ControlLabel>
                <Panel>
                  <RichTextEditor
                    type={page.details.body_content_type}
                    text={page.body || ''}
                    onChange={value => this.handlePageBodyChange(value)}
                  />
                </Panel>
              </FormGroup>
            </Col>
          </Row>
          {TemplateComponent ? (
            <TemplateComponent page={this.state.page.details} />
          ) : (
            <Alert bsStyle='warning'>Template Does not Exist.</Alert>
          )}
        </Col>
        <Col xs={12} md={4}>
          <Panel
            bsStyle={'tertiary'}
            header={(
              <h3>Publish Settings</h3>
            )}
            footer={(
              <Row>
                <Col xs={12}>
                  {page_manager.error ? <Alert bsStyle={'danger'}>{page_manager.error && page_manager.error.message}</Alert> : null}
                  {last_autosave ? <p>{moment(last_autosave).fromNow()}</p> : null}
                  {page_manager.saving ? <p><i className='fa fa-spinner fa-spin'></i> Saving...</p> : null}
                </Col>
                <Col xs={6}>
                  <Button onClick={e => this.props.push('/sales-site')} bsStyle={'default'} block>Cancel</Button>
                </Col>
                <Col xs={6}>
                  {dirty ? <Button onClick={this.save}><i className='fa fa-save'></i></Button> : null}
                  {!page.published ? <Button onClick={e => this.handlePageChange('published', true)} bsStyle={'primary'}> Publish</Button> : <Button onClick={e => this.handlePageChange('published', false)} bsStyle={'warning'}>Unpublish</Button>}
                </Col>
              </Row>
            )}
          >
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <ControlLabel>Publish Date</ControlLabel>
                  <DatetimeRangePicker
                    singleDatePicker
                    timePicker
                    startDate={moment(page.published_timestamp || new Date())}
                    onApply={this.handlePublishTimestamp}
                  >
                    <div className="input-group">
                      <input type="text" className="form-control" readOnly={true} value={label || ''}/>
                        <span className="input-group-btn">
                            <Button className="default date-range-toggle">
                              <i className="fa fa-calendar"/>
                            </Button>
                        </span>
                    </div>
                  </DatetimeRangePicker>
                </FormGroup>
                {page.published ? (
                  <Alert bsStyle='info'>
                    <p><strong>Published</strong> on {moment(page.published_timestamp).format('MMM DD, YYYY hh:mm a')}</p>
                  </Alert>
                ) : null}
              </Col>
            </Row>
          </Panel>
        </Col>
        <Col xs={12}>
          <h3>Preview</h3>
          {this.state.page._id ? <iframe style={{ border: 'none', width: '100%', height: 500}} src={`https://hailtrace.com/preview${this.state.page._id ? '/' + this.state.page._id : ''}`}></iframe> : null}
        </Col>
      </Row>
    )
  }
}

export default connect(PageProducer);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/page-producer.js